import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import animator from '../../../../helpers/animator';
import dataModel from '../../../../models/DataModel';
import pencilIcon from '../../../../assets/images/pencil.svg';
import pencilIconGray from '../../../../assets/images/pencil-highlight.svg';
import TaskMenuPopup from '../../../../components/TaskMenuPopup';
import TaskCardInner from '../../../../components/TaskCardInner';
import './TaskCard.scss';

const task_attributes_and_cc = {
  task: {
    completion_criteria: {},
  },
};

class TaskCard extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = { 
      selectedUser: null,
      task: null,
    };
  }

  async handleActionCable(fetchedData, acData) {
    if (this.state.task && fetchedData && fetchedData.id == this.state.task.id) {
      this.setState({ task: fetchedData });
    }
  }

  componentDidMount() {
    super.componentDidMount();
    //must perform getTask
    dataModel.tasksDAO.getTask(this.props.taskId, { recordDescriptor: task_attributes_and_cc }).then(task => {
      this.setState({ task });
    });
    //will also register for action cable
    dataModel.actionCableConnector.registerCallback(this.handleActionCable, ['updateTask'], [this.props.taskId], task_attributes_and_cc);
  }

  componentWillUnmount() {
    dataModel.actionCableConnector.unregisterCallback(this.handleActionCable, ['updateTask'], [this.props.taskId]);
  }

  handleOnHoverIn() {
    if (this.props.permissions && this.props.permissions.canEditTask && this.props.permissions.canEditProjectTemplate) {
      this.setState({ hoveredOver: true });
    }
  }

  handleOnHoverOut() {
    this.setState({ hoveredOver: false });
  }

  handlePencilOnHoverIn() {
    this.setState({ pencilHoveredOver: true });
  }

  handlePencilOnHoverOut() {
    this.setState({ pencilHoveredOver: false });
  }

  handleSelection() {
    this.props.handleTaskSelect(this.state.task);
  }

  handlePrepareDrag(xPos, yPos) {
    this.dragElement = this.cardElement;
    this.startX = xPos;
    this.startY = yPos;
  }

  handleStartDrag(element) {
    if (!this.dragging && this.dragElement && this.dragElement == element && !this.dragObject) {
      this.dragging = true;
      let bodyElement = document.body;
      this.dragObject = element.cloneNode(true);
      this.dragObject.style.position = 'absolute';
      this.dragObject.style.transform = 'rotate(-10deg)';
      this.dragObject.style.zIndex = 1000;
      this.dragObject.style.opacity = .8;
      const bodyRect = bodyElement.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      this.xPos = elementRect.left - bodyRect.left;
      this.yPos = elementRect.top - bodyRect.top;
      this.yOffset = this.startY - this.yPos;
      this.dragObject.style.top = this.yPos + 'px';
      this.dragObject.style.left = this.xPos + 'px';
      bodyElement.addEventListener('mousemove', this.handleDragging);
      bodyElement.addEventListener('mouseup', this.handleEndDragging);
      bodyElement.appendChild(this.dragObject);
    }
  }

  handleDragging(e) {
    let top = e.clientY - this.yOffset;

    this.dragObject.style.top = top + 'px';
    if (this.props.handleDragging) {
      this.props.handleDragging(this.state.task, this.xPos, top);
    }
  }

  handleEndDragging(e) {
    this.dragging = false;
    let bodyElement = document.body;
    bodyElement.removeEventListener('mousemove', this.handleDragging);
    bodyElement.removeEventListener('mouseup', this.handleEndDragging);
    bodyElement.removeChild(this.dragObject);
    this.dragElement = null;
    this.dragObject = null;
    if (this.props.handleDropping) {
      let top = e.clientY - this.yOffset;
      this.props.handleDropping(this.state.task, this.xPos, top);
    }
  }

  handleMouseDown(e) {
    e = this.fixupMouse(e);
    if (e.which == 1) {
      if (this.props.handleDragging) {
        this.handlePrepareDrag(e.clientX, e.clientY);
        document.body.classList.add('no-select');
      }
    }
  }

  handleMouseUp(e) {
    this.dragElement = null;
    document.body.classList.remove('no-select');
  }

  handleMouseMove(e) {
    if (this.props.permissions.canEditProjectTemplate) {
      e = this.fixupMouse(e);
      if (this.props.handleDragging) {
        if (!this.dragging && e.which == 1) {
          if ((this.startX && Math.abs(this.startX - e.clientX) > 5) ||
            (this.startY && Math.abs(this.startY - e.clientY) > 5)) {
            this.handleStartDrag(this.cardElement);
          }
        }
      }
    }
  }

  handlePencilClick(e) {
    e.stopPropagation();
    this.setState({ menuOpen: true, hoveredOver: false, pencilHoveredOver: false });
  }

  handleCloseTaskMenu() {
    this.setState({ menuOpen: false, hoveredOver: false, pencilHoveredOver: false });
  }

  handleTaskDeleted(task) {
    if (this.props.handleTaskDeleted) {
      this.props.handleTaskDeleted(task);
    }
  }

  render() {
    const { task } = this.state;
    if (!task) {
      return null;
    }
    let pencil = pencilIcon;
    if (this.state.pencilHoveredOver) {
      pencil = pencilIconGray;
    }

    let taskPopupMenu = null;
    if (this.state.menuOpen && this.cardElement) {
      const rects = this.cardElement.getClientRects();
      taskPopupMenu = (
        <TaskMenuPopup 
          task={this.state.task}
          cardRect={rects[0]}
          handleClosePopup={this.handleCloseTaskMenu}
          handleTaskDeleted={this.handleTaskDeleted}
          handleAddCopiedTask={this.props.handleAddCopiedTask}
          currentUser={this.props.currentUser}
          isFromTemplate={true}
        />
      );
    }

    return (
      <div>
        {taskPopupMenu}
        <div className={'template-task-card' + (this.props.isTaskCopied ? ' fade-in' : '')}
          onClick={this.handleSelection} id={this.props.taskId}
          onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp}
          onMouseMove={this.handleMouseMove} ref={(element) => { this.cardElement = element; }}
          onMouseEnter={this.handleOnHoverIn} onMouseLeave={this.handleOnHoverOut}
        >
          <TaskCardInner task={this.state.task} selectDisabled={this.props.selectDisabled} />
             {this.state.hoveredOver && !this.props.readOnly && (
            <div className={'pencil-icon' + (this.state.pencilHoveredOver ? ' hovered-over' : '')}
              onMouseEnter={this.handlePencilOnHoverIn} onMouseLeave={this.handlePencilOnHoverOut}
              onClick={this.handlePencilClick}
            >
              <img
                alt="edit" src={pencil} onClick={this.handlePencilClick}
              />
            </div>
          )}
     </div>
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  let project = ownProps['project'];
  if (project && state.projects['project_' + project.id]) {
    project = state.projects['project_' + project.id].project;
  }
  let task = ownProps['task'];
  if (task && state.tasks['task_' + task.id]) {
    task = state.tasks['task_' + task.id].task;
  }
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    project: project,
    task: task,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default connect(mapStateToProps)(TaskCard);



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTemplateTasks/TaskCard/index.js